<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading" class="w-full overflow-x-auto">

    <div class="w-full px-10 pb-7 pt-4 bg-tileLight dark:bg-[#363636] rounded-lg ">

        <div class="w-full dark:bg-[#363636]">
            <div class="flex flex-row items-center justify-center">
                <p class="text-lg font-semibold text-[#292929] mx-3 dark:text-white">From :</p>

                <div class="relative w-56 mr-10">
                    <app-custom-datepicker #fromDatePicker [placeholder]="'--Select Date--'" [(selectedDate)]="fromDate"
                        (dateChange)="onFromDateChange($event)">
                    </app-custom-datepicker>
                </div>

                <p class="text-lg font-semibold text-[#292929] mx-3 dark:text-white">To :</p>

                <div class="relative w-56 mr-6">
                    <app-custom-datepicker #toDatePicker [placeholder]="'--Select Date--'" [selectedDate]="toDate"
                        (dateChange)="onToDateChange($event)">
                    </app-custom-datepicker>
                </div>

                <button (click)="goBtn()"
                    class="bg-[#415CFF] text-lg text-white font-semibold px-6 py-2 rounded-lg shadow-lg ml-5 dark:text-white">
                    Go
                </button>
            </div>
        </div>

    </div>

    <hr />

    <div *ngIf="hasData && isDateFilterSet">
        <div class="flex flex-row items-center justify-between mt-6 mr-5">
            <div class="flex flex-row gap-4">
                <div class="flex flex-col justify-between flex-shrink-0">
                    <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">All Transactions
                        ( {{totalItems | number:'2.0-0'}} )</p>
                </div>
            </div>

            <div class="flex flex-row items-center gap-5 ">
                <i *ngIf="logingRole === 'Collection Centre Head'"
                    class="fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white ml-8"></i>

                <p *ngIf="logingRole === 'Collection Centre Head'"
                    class="font-normal text-[16px] text-[#4A4A4A] dark:text-white">
                    Filter By
                </p>

                <div class="relative w-52 custom-center-dropdown-container">
                    <div *ngIf="logingRole === 'Collection Centre Head'">
                        <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Select Centre..."
                            searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                            (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                            [disabled]="false" class="w-full"></app-searchable-dropdown>

                    </div>
                </div>



                <div class="flex items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by GRN No, NIC..." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (input)="checkLeadingSpace()" (keyup.esc)="offSearch()"
                        (ngModelChange)="searchText = $event.trimStart()"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div class="flex justify-between items-center mb-5 mt-3"> <!-- Changed this line -->
            <div class="text-lg font-medium">
                <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">
                    <span class="text-gray-500 dark:textDark">Total : </span>Rs {{ grandTotal | number:'1.2-2'
                    }}
                </p>
            </div>

            <button
                class="bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 mr-5 text-lg flex items-center"
                (click)="downloadTemplate1()">
                <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
                <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
                {{ isDownloading ? " Downloading..." : " Download" }}
            </button>
        </div>




        <div *ngIf="hasData" class="min-w-max overflow-hidden  mt-5 mr-5">
            <div class=" border-gray-100 border-[2px] dark:border-[#202021] rounded-lg">
                <table class="w-full min-w-max divide-y-2">
                    <thead class=" dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] text-[#4B5563]">
                        <tr>
                            <th class="px-2 py-3 text-center  font-medium">No</th>
                            <th class="px-3 py-3 text-left  font-medium">GRN No</th>
                            <th class="px-3 py-3 text-left  font-medium">Amount (Rs.)</th>
                            <th class="px-3 py-3 text-left  font-medium"
                                *ngIf="logingRole === 'Collection Centre Head'">
                                Centre Code</th>
                            <th class="px-3 py-3 text-left font-medium" *ngIf="logingRole === 'Collection Centre Head'">
                                Centre Name</th>
                            <th class="px-3 py-3 text-left font-medium ">Farmer NIC</th>
                            <th class="px-3 py-3 text-center font-medium">Collected Time</th>
                            <th class="px-3 py-3 text-center font-medium"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-[#000000] font-semibold dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                        <tr *ngFor="let item of farmerPaymentsArr | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  };  let i = index">
                            <td class="px-2 py-4 text-center text-gray-900 dark:text-gray-300 ">
                                {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i +
                                    1) : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                            <td class="px-3 py-4 text-gray-900 dark:text-gray-300">{{item.invNo}}</td>
                            <td class="px-3 py-4 text-gray-900 dark:text-gray-300 ">
                                {{item.totalAmount | number:'1.2-2'}}
                            </td>
                            <td class="px-3 py-4  text-gray-900 dark:text-gray-300"
                                *ngIf="logingRole === 'Collection Centre Head'">{{item.centerCode}}</td>
                            <td class="px-3 py-4 text-gray-900 dark:text-gray-300"
                                *ngIf="logingRole === 'Collection Centre Head'">{{item.centerName}}</td>
                            <td class="px-3 py-4  text-left text-gray-900 dark:text-gray-300">{{item.nic}}</td>
                            <td class="px-3 py-4 text-center text-[#646464] dark:text-gray-300">
                                <span class="block">{{ item.createdAt | date: 'MMMM d, y'}}</span>
                                <span class="block">{{ item.createdAt | date: 'hh:mm a' }}</span>
                            </td>
                            <td class="px-3 py-4 text-center dark:text-gray-300">
                                <i (click)="navigateToFarmerReport(item.invNo)"
                                    class="fa-solid fa-arrow-up-right-from-square cursor-pointer text-[#415CFF]"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>

    </div>

    <!-- <div *ngIf="!isDateFilterSet" class="flex justify-center items-center mt-8 mr-5 h-[500px] dark:bg-[#292929] ">
        <p class="text-3xl text-center font-semibold dark:text-white">--Set From & To Dates first--</p>
    </div> -->

    <div *ngIf="!isDateFilterSet" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
        <p class="text-[#494949] my-6 dark:text-textDark">--Set From & To Dates first--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

    <div *ngIf="!hasData && isDateFilterSet" class="h-[500px]">
        <div class="flex flex-row items-center justify-between mt-6">
            <div class="flex flex-row gap-4">
                <div class="flex flex-col justify-between flex-shrink-0">
                    <p class="font-semibold mb-1 text-lg dark:text-white whitespace-nowrap">All Transactions
                        ( {{totalItems < 10 ? '0' + totalItems : totalItems }} )</p>
                </div>
            </div>

            <div class="flex flex-row items-center gap-5 ">
                <i *ngIf="logingRole === 'Collection Centre Head'"
                    class="fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white ml-8"></i>

                <p *ngIf="logingRole === 'Collection Centre Head'" class="font-normal dark:text-white">Filter By</p>

                <div class="relative w-64 custom-center-dropdown-container"
                    *ngIf="logingRole === 'Collection Centre Head'">
                    <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Select Centre..."
                        searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                        (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                        [disabled]="false" class="w-full"></app-searchable-dropdown>
                </div>

                <div class="flex items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by GRN No & NIC..." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                        (ngModelChange)="searchText = $event.trimStart()"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-col items-center w-full px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>
    </div>
</div>